import Vue from 'vue'
import Router from 'vue-router'
import { h5Routes } from './h5'
import { pcRoutes } from './pc'

let isPhone = function() {
    let width = window.innerWidth;
    console.log(width);
    let flag = true;
    if (width < 800) {
        flag = false
    }
    return flag
};

let ispc = isPhone();
console.log(ispc)


Vue.use(Router)

export default new Router({
    routes: ispc ? pcRoutes : h5Routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },

})


// WEBPACK FOOTER //
// ./src/router/index.js